module.exports = __webpack_public_path__ + "media/images/circle02-638f3de4f6d7af6bade643175da21783.svg";